export function SectionHeading({ title, filters }) {
  return (
    <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-1">
      {/* Title */}
      <h3 className="text-xl font-semibold text-gray-900">{title}</h3>

      {/* Filters Container – no extra border/shadow here */}
      <div className="flex flex-wrap gap-3">
        {filters}
      </div>
    </div>
  );
}